var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Fillable, Path, PrimaryKey, RestModel } from 'ng-rest-model';
var Comment = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Comment_1 = Comment;
    Comment.toBeModerated = function (options) {
        return new this().fetchToBeModerated(options);
    };
    Comment.prototype.fetchToBeModerated = function (options) {
        return this.http.get(this.itemUrl('all').build(), options).map(function (resp) { return resp.map(function (c) { return new Comment_1().init(c); }); });
    };
    Comment.prototype.show = function () {
        return this.http.put(this.itemUrl(this.id).all('moderated').build(), { moderated: true })
            .map(this.init.bind(this));
    };
    __decorate([
        PrimaryKey(),
        __metadata("design:type", Number)
    ], Comment.prototype, "id", void 0);
    __decorate([
        Fillable(),
        __metadata("design:type", Boolean)
    ], Comment.prototype, "moderated", void 0);
    __decorate([
        Fillable(),
        __metadata("design:type", String)
    ], Comment.prototype, "commenter", void 0);
    __decorate([
        Fillable(),
        __metadata("design:type", String)
    ], Comment.prototype, "text", void 0);
    Comment = Comment_1 = __decorate([
        Path('comments')
    ], Comment);
    return Comment;
    var Comment_1;
}(RestModel));
export { Comment };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/who-we-are/classes/comment.ts.pre-build-optimizer.js